export const urlWithRedirect = (url: string, target?: string | null) => {
  const [path, params] = url.split('?');
  const searchParams = new URLSearchParams();

  if (params) {
    params.split('&').forEach((param) => {
      const [k, v] = param.split('=');
      searchParams.append(k, v);
    });
  }

  if (target) {
    searchParams.set('redirectTo', target);
  }

  return path + (Array.from(searchParams).length !== 0 ? `?${searchParams.toString()}` : '');
};
